/**
 * Shared layout for the pre-login funnel (ValueOnboarding → Auth).
 *
 * These screens are designed phone-first and are full-bleed on mobile, but the
 * web build renders them at whatever width the browser is. Unconstrained, the
 * foliage CTA stretches the full width of a desktop monitor — a 1400px pill
 * under a 310px headline, which reads as broken rather than roomy.
 *
 * Constrain the COLUMN, not the button: everything inside (wordmark row, hero,
 * plan cards, dots, CTA, form fields) then shares one measure, so the funnel
 * looks like the same product at every step and at every viewport. Each screen
 * keeps its own horizontal padding, so the CTA lands at the same width across
 * the handoff only when the padding matches too — they all use `px-7`.
 *
 * Mobile is unaffected: `max-w-md` (28rem / 448px) is wider than every phone
 * viewport we target, so this is purely a desktop ceiling.
 */
export const FUNNEL_COLUMN = 'mx-auto w-full max-w-md';
